var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"fas fa-circle",class:{
        'implanted': _vm.status == 'IMPLANTED',
        'started': _vm.status == 'STARTED',
        'waiting-first-request': _vm.status == 'WAITING_REQUEST',
        'suspended': _vm.status == 'SUSPENDED',
        'on-alert': _vm.status == 'ON_ALERT',
        'on-watch':  _vm.status == 'ON_WATCH' },attrs:{"title":_vm.translated_title}})}
var staticRenderFns = []

export { render, staticRenderFns }